module.exports = __webpack_public_path__ + "img/1.3eaad2f4.png";